import { Text, Texture } from "pixi.js";
import { LatestNewsResourcePackage } from "../../resources/LatestNewsResourcePackage";
import { INewsItemOptions } from "./NewsItem";
import { NewsTextStyle } from "../styles/NewsTextStyle";
import { UserProfileResourcePackage } from "../../../userprofile/resources/UserProfileResourcePackage";
import { NewsItemWithAvatar } from "./NewsItemWithAvatar";

export class NewsItemRaidWithShield extends NewsItemWithAvatar {
    private static readonly RAIDED_TEXT = 'RAIDED YOUR BUILDING AND WAS\nBLOCKED BY YOUR SHIELD -\nNO DAMAGE WAS DONE';

    private nameText: Text;
    private raidedText: Text;

    public constructor(
        id: string,
        newsResources: LatestNewsResourcePackage,
        userProfileResources: UserProfileResourcePackage,
        options: NewsItemRaidWithShieldOptions
    ) {
        super(
            id,
            newsResources,
            userProfileResources,
            newsResources.assets_views_latest_news_news_tooltip_red_png,
            newsResources.assets_views_latest_news_news_shield_png,
            options.playerAvatarTexture
        );
        this.build(options);
        this.layout();
    }

    private build(options: NewsItemRaidWithShieldOptions): void {
        this.nameText = new Text(options.playerName, new NewsTextStyle());
        this.raidedText = new Text(NewsItemRaidWithShield.RAIDED_TEXT, new NewsTextStyle());
        this.avatar.updateTexture(options.playerAvatarTexture);

        this.addChild(this.nameText, this.raidedText);
    }

    private layout(): void {
        this.nameText.position.set(411, 30);
        this.raidedText.position.set(411, 72);
    }
}

export class NewsItemRaidWithShieldOptions implements INewsItemOptions {
    public readonly playerName: string;
    public readonly playerAvatarTexture: Texture;

    public constructor(playerName: string, playerAvatarTexture: Texture) {
        this.playerName = playerName;
        this.playerAvatarTexture = playerAvatarTexture;
    }
}